import _ from 'lodash';

var c = require("infra/utils/common");
var getTimeframeLabel = function (entry, field) {
    return c.getTimeframeLabel(entry, field.format);
};

const getTimezoneLabel = (entry) => entry.label;

var getBooleansLoginSummary = function(booleans, field) {
  if (_.isEmpty(booleans)) return undefined;
  var key   = field.pkey || 'text';
  var entries = [];
  var boolNames = [];
  var requires = [bold('Always about:')], includes = [bold('Prefer content about:')], excludes = [bold('Never about:')];
  _.each(booleans, function(bool) {
    var boolName = bool[key];
    boolNames.push(boolName);

    var boolSummary = [];
    requires.push(bool.required.join());
    includes.push(bool.included.join());
    excludes.push(bool.excluded.join());
  });

  return {title: boolNames, data: [requires, includes, excludes]};
};

var NOT_AVAILABLE = 'NA';
// boolean_logics is atteched twice, one time just for the boolean name and one time for the breakdown.

var getParameterSummary = function (p, field) {
    var key = field.pkey || 'text';
    var empty = field.empty || 'All';
    var entry = _.isArray(p) ? _.map(p, key).join(', ') : p[key];

    return entry.length > 0 ? entry : empty;
};

var getExportDate = function (date) {
    return (c.isDate(date) ? date : moment()).format('YYYY-DD-MM (HH:mm)');
};

var bold = function (label) {
    return {value: label, metadata: {style: 1}};
};

var getExportFileName = function (title, date) {
    return title + ' ' + getExportDate(date);
};

const getChannelName = function(key){
    const mapping = {
      'articles': 'All',
      'videos': 'Video',
      'sg_telco': 'Web - SG Telco',
      'sg_bidstream': 'Web - SG Bidstream',
      'bidstream': 'Historical Bidstream',
      'au_telco': 'AU Telco'
    };

    return mapping[key] || key || 'All';
};


const DEFAULT_SUMMARY_PARAMETERS = [
  {key: 'timeframe',      label: 'Content From:',    value_f: getTimeframeLabel, format: 'YYYY-MM-DD' },
  {key: 'terms',          label: 'Seeds:',           pkey: 'text',  empty: 'None' },
  {key: 'boolean_logics', label: 'Refined Seeds:',   pkey: 'text',  empty: 'None' },
  {key: 'topics',         label: 'Filtered Topics:', pkey: 'name',  empty: 'All'  },
  {key: 'geo',            label: 'Geo:',             pkey: 'label', empty: 'All'  },
  {key: 'sub_geos',       label: 'Sub Geos:',        pkey: 'label', empty: 'All'  },
  {key: 'channel',        label: 'Channel:',         value_f: getChannelName, empty: 'All'  },
  {key: 'boolean_logics', label: 'Refined Seeds:',   value_f: getBooleansLoginSummary, pkey: 'text',  empty: 'None', attached_at_end: true }
];

const AUDIENCE_SUMMARY_FIELD = {key: 'audience', label: 'Audience:', pkey: _.identity};
const FIRST_PARTY_SEGMENTS_SUMMARY_FIELD = {key: 'first_party_audience', label: '1st Party Segments:', pkey: _.identity};
const TIMEZONE_SUMMARY_FIELD = {key: 'timezone', label: 'Time Zone:', value_f: getTimezoneLabel };

const PERMISSION = {
    SMART_TVA_LITE: 'smart tva lite',
    WEB: 'web',
    FIRST_PARTY_SEGMENT: 'first party segments',
    TVA_CUSTOM_TIMEFRAME: 'tva custom timeframe',
    GEO_US: 'geos.US',
    SG_TELCO_ETHNICITY: 'sg telco ethnicity',
    ACTIVE_TARGETS: 'activate targets',
    TV_ACTIVATION: 'tv activation',
    AUDIENCE_ACTIVATION_ALWAYS_ON: 'audience activation - always on',
    AUDIENCE_AU_TELCO_CHANNEL: 'audience au telco channel',
    AUDIENCE_LINKEDIN_CHANNEL: 'audience linkedin channel',
    AUDIENCE_SG_TELCO_CHANNEL: 'audience sg telco channel',
    CREATE_DETERMINISTIC_SEGMENT: 'create a deterministic segment',
    ALLOW_CUSTOM_PRICE_SEGMENT: 'allow custom price segment',
    OPTIMIZE_SEGMENT: 'optimize segment',
    SHOW_AUDIENCE_IP_COUNT: 'show audience ip count'
};

module.exports = {
    NOT_AVAILABLE: NOT_AVAILABLE,
    DEFAULT_SUMMARY_PARAMETERS: DEFAULT_SUMMARY_PARAMETERS,
    AUDIENCE_SUMMARY_FIELD: AUDIENCE_SUMMARY_FIELD,
    FIRST_PARTY_SEGMENTS_SUMMARY_FIELD: FIRST_PARTY_SEGMENTS_SUMMARY_FIELD,
    TIMEZONE_SUMMARY_FIELD: TIMEZONE_SUMMARY_FIELD,
    PERMISSION,

    getExportDate: getExportDate,
    getExportFileName: getExportFileName,
    getBooleansLoginSummary: getBooleansLoginSummary,
    getQuerySummary: function (format, parameters, date, fields) {

        var summary = {name: 'Summary', table: [[format('Generated At:', 'bold'), getExportDate(date)]]};
        _.each(c.isArray(fields) ? fields : DEFAULT_SUMMARY_PARAMETERS, function (field) {
            var entry = parameters[field.key];
            if (!c.is(entry) && !field.value_f) {
              return;
            }
            var value_f = field.value_f || getParameterSummary;
            entry = value_f(entry, field);
            if(_.isObject(entry)) {
              summary.table.push([]); // new line
              summary.table.push([format(field.label, 'bold')].concat(entry.title));
              summary.table = summary.table.concat(entry.data);
            } else if (entry) {
              summary.table.push([format(field.label, 'bold'), entry]);
            }
        });
        summary.columns = [{width: 20}, {width: 40}];
        return summary;
    }
};
